import { useEffect, useState } from "react";
import { _ProductionOrder, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { AccountEditor } from "../../../editor/AccountEditor";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { SelectProject } from "../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { SelectManufacturingStandars } from "../../ManufacturingStandars/SelectManufacturingStandars";
import { SelectAttentionOffice } from "../../ProductionOrder/Components/SelectAttentionOffice";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectProductionOrderStateConstants } from "../../ProductionOrder/Components/SelectProductionOrderStateConstants";
import { SelectProductEditor } from "../../ManufacturingStandars/Components/SelectProductEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { QualityInspectionOperation } from "./QualityInspectionOperation/QualityInspectionOperation";
import { QualityInspectionProduct } from "./QualityInspectionProduct/QualityInspectionProduct";
import { QualityInspectionProductRamdom } from "./QualityInspectionProductRamdom/QualityInspectionProductRamdom";
import { QualityInspectionChangeParts } from "./QualityInspectionChangeParts/QualityInspectionChangeParts";

interface Props {
    isModal?: boolean;
    onChange?: Function;
}

export const QualityProductionOrder = ({ isModal, onChange }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_ProductionOrder);

    const paginador = usePaginator();

    const modalOperation = useModal("Inpección de Operaciones", MODAL_XL)
    const modalProduct = useModal("Inpección de Producto", MODAL_XL)
    const modalProductRamdom = useModal("Inpección de Producto Terminado Aleatoria", MODAL_XL)
    const modalSwap = useModal("Cambio de Piezas de la Orden", MODAL_XL)

    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        FromDate: null,
        UptoDate: null,
        IDProject: NaN,
        IDManufacturingStandart: NaN,
        IDAttentionOffice: NaN,
        IDStore: NaN,
        State: NaN,
    })

    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        instance.getProductionOrderCatalog(form.IDAccount, form.IDProduct ?? null, form.Code ?? null, form.Year, form.MonthVigency ?? null, form.FromDate, form.UptoDate, form.IDProject, form.IDManufacturingStandart, form.IDAttentionOffice, form.IDStore, form.State, paginador.page, 15).then(
            (resp) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    const x = resp.List.map(element => {
                        element.DataBeanProperties.EntityUnit = element.DataBeanProperties.MeasurementUnitCode ? `${element.DataBeanProperties.MeasurementUnitCode} - ${element.DataBeanProperties.MeasurementUnitName}` : "N/A"
                        return element;
                    });
                    setLista(x);
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDProductionOrder', visible: true },
        { title: 'Cliente', property: 'IDAccount', visible: true, mask: MASK_NUMBER },
        { title: 'Código Orden de Producción', property: 'Code', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha de la Orden de Producción', property: 'ProductionOrderDate', visible: true },
        { title: 'Centro de Fabricación', property: 'AttentionOfficeName', visible: true },
        { title: 'Fecha Fin', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Tipo de Solicitud', property: 'TypeName', visible: false },
        { title: 'No Solicitud Cliente', property: 'ExternalRequestReference', visible: true },
        { title: 'Cliente/Solicitante', property: 'ContractName', visible: true },
        { title: 'Estandard de Fabricación', property: 'ManufacturingStardardName', visible: true },
        { title: 'Producto a Producir', property: 'ProductName', visible: true },
        { title: 'Ruteo de Producción', property: 'ProductionRouteName', visible: true },
        { title: 'Variante/Talla', property: 'ProductVariantName', visible: true },
        { title: 'Unidad de Medida', property: "EntityUnit", visible: true },
        { title: 'Línea de Negocio', property: 'BusinessCoreName', visible: false },
        { title: 'Cantidad a Producir', property: 'Quantity', visible: true },
        { title: 'Estado', property: 'StateName', visible: false },
        { title: 'Estado de la Operación', property: 'OrderStateName', visible: true },
        { title: 'Documento Orden de Producción', property: 'POConsecutive', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
        { title: 'No Solicitud Cliente', property: 'ExternalRequestReference', visible: false },
        { title: 'Observaciones', property: 'Description', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Inspección de Calidad de Operación', icono: 'ri-checkbox-line', visible: _single.canCreate(), evento: () => { modalOperation.open() } },
            { titulo: 'Cumplimiento de requisitos Generales de Producto', icono: 'mdi mdi-briefcase-check-outline', visible: _single.canCreate(), evento: () => { modalProduct.open() } },
            { titulo: 'Inspección Aleatoria de Productos Terminados', icono: 'mdi mdi-archive-check-outline', visible: _single.canCreate(), evento: () => { modalProductRamdom.open() } },
            // { titulo: 'Cambio de Pieza', icono: 'mdi mdi-file-swap-outline', visible: _single.canCreate(), evento: () => { modalSwap.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFieldsForm, setMissingFieldsForm] = useState<string[]>([]);

    const validateForm = () => {
        if (validateDataForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            getLista();
        }
    }

    const validateDataForm = () => {
        console.log(form)
        const requiredFields = [
            "Year"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (form[field] === null || form[field] === undefined || form[field] === "" || Number.isNaN(form[field])) {
                missing.push(field);
            }
        }
        console.log(missing)
        setMissingFieldsForm(missing);
        return missing.length;
    };

    const setRowBean = (obj) => {
        setBean(obj)
        if (onChange) {
            onChange(obj)
        }
    }

    const rowContent = (
        <div className="row">
            <div className="col-md-4">
                <AccountEditor idAccount={null} label="Cliente" onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }} />
            </div>
            <div className="col-md-4">
                <label className={`${missingFieldsForm.includes('Year') ? 'has-error' : ''}`}>Año/Vigencia</label>
                <YearSelector tittle=" " onChange={(e) => { setForm({ ...form, "Year": e }) }} />
            </div>
            <div className="col-md-4">
                <label className={`${missingFieldsForm.includes('MonthVigency') ? 'has-error' : ''}`}>Mes</label>
                <MonthConstantsEditor idSelect={form.MonthVigency} onChange={(e) => { setForm({ ...form, "MonthVigency": e }) }} label=" " name="" />
            </div>
            <div className="col-md-6">
                <SelectProject idSelector={form.IDProject} onChange={(e) => { setForm({ ...form, "IDProject": e }) }} label="Proyecto" />
            </div>
            <div className="col-md-6">
                <SelectManufacturingStandars idSelector={form.IDManufacturingStandart} onChange={(e) => { setForm({ ...form, "IDManufacturingStandart": e }) }} label="Estandard de Fabricación" />
            </div>
            <div className="col-md-6">
                <SelectAttentionOffice idSelector={form.IDAttentionOffice} onChange={(e) => { setForm({ ...form, "IDAttentionOffice": e }) }} label="Centro de Fabricación" />
            </div>
            <div className="col-md-6">
                <SelectStoreEditor idSelector={form.IDStore} label="" onChange={(e) => { setForm({ ...form, "IDStore": e.IDStore }) }} />
            </div>
            <div className="col-md-6">
                <SelectProductionOrderStateConstants idSelector={form.State} onChange={(e) => { setForm({ ...form, "State": e }) }} label="Estado de la Orden de Producción" />
            </div>
            <div className="col-md-6">
                <SelectProductEditor filterType={3} label="Producto Final" value={form.IDProduct} onChange={(e) => { setForm({ ...form, "IDProduct": e.IDProduct }) }} />
            </div>
            <div className="col-md-6">
                <label >Código de Orden</label>
                <input type="number" className="form-control" value={form.Code} onChange={(e) => { setForm({ ...form, "Code": e.target.value }) }} />
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton eventClick={validateForm} icon="ri-search-line" children={"Buscar"} />
            </div>
            <div className="col-md-12">
                <BasicTable
                    listButtons={listaBotones()}
                    head={head} body={lista}
                    rowSet={setRowBean}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />
            </div>
        </div>
    );

    return isModal ? rowContent : (
        <BasicPage titulo="Ordenes de Producción - Calidad">
            {rowContent}

            <div className="col-md-12">
                <Modal modal={modalOperation.modal} updateModal={modalOperation.setModal} >
                    <QualityInspectionOperation _ProductionOrder={bean} isModal />
                </Modal>

                <Modal modal={modalProduct.modal} updateModal={modalProduct.setModal} >
                    <QualityInspectionProduct _ProductionOrder={bean} isModal />
                </Modal>

                <Modal modal={modalSwap.modal} updateModal={modalSwap.setModal} >
                    <QualityInspectionChangeParts _ProductionOrder={bean} isModal />
                </Modal>

                <Modal modal={modalProductRamdom.modal} updateModal={modalProductRamdom.setModal} >
                    <QualityInspectionProductRamdom _ProductionOrder={bean} isModal />
                </Modal>
            </div>
        </BasicPage>
    );
}



